import { useMemo } from 'react';
import { getUser } from '@frontend/auth-helpers';
import { useScopedAppFlagStore } from '@frontend/scope';
import { MarketingAttributionsFeatureFlags } from '../feature-flags';

const DEMO_ACCOUNT_SUFFIX = ['@demoweave.com'];

export const useCheckMarketingAttributionDemoAccount = () => {
  const user = getUser();
  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const isDemoFeatureEnabled = useMemo(
    () => getFeatureFlagValue(MarketingAttributionsFeatureFlags.demoEnabled),
    [getFeatureFlagValue]
  );
  const isDemoUser = DEMO_ACCOUNT_SUFFIX.some((suffix) => user?.username?.endsWith(suffix));

  return isDemoFeatureEnabled && isDemoUser;
};
